import React from 'react';
import { Helmet } from 'react-helmet-async';
import Section from './Section';
import { Container } from 'reactstrap';
import DashboardContent from './DashboardContent';
import DashBoardDesign from './DashboardDesign'
const ManageJobApplications = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Dashboard | Webvi </title>
      </Helmet>
      <Section />
      <section className="section">
        <Container>
         
         
           <DashBoardDesign/>
            <DashboardContent />
        </Container>
      </section>
    </React.Fragment>
  )
}

export default ManageJobApplications